import {
  DashboardModuleListItem,
} from '@domain-group/suit-theme'

import useAddress from '@hooks/useAddress'

import { getFullAddress } from '@functions/address'

import type { AddressModel } from '@models/types'

type ShippingAddressProps = {
  address: AddressModel,
}

const ShippingAddress = (props: ShippingAddressProps) => {
  const { address } = props

  const {
    is_default,
    title,
  } = address

  const { callbacks: { createOrEditAddress } } = useAddress(address)

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditAddress()}
      secondaryText={getFullAddress(address)}
      title={title}
    >
      {is_default && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.TertiaryText textProps={{ color: 'lightGrey' }}>
          Default Address
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      )}
    </DashboardModuleListItem>
  )
}

export default ShippingAddress
